/**
 * Dashboard Entry Point
 * 
 * @package TopBuddy
 */

import { createRoot } from '@wordpress/element';
import App from './App';
import './style.scss';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
	const rootElement = document.getElementById('topbuddy-dashboard-root');
	
	if (rootElement) {
		const root = createRoot(rootElement);
		root.render(<App />);
	}
});

